import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { DevStateResolver } from 'app/modules/dev/dev-resolvers';
import { BannedAccountInterceptor } from 'core/interceptors/token/banned-account.interceptor';
import { RefreshTokenInterceptor } from 'core/interceptors/token/refresh-token.interceptor';
import { CourierService } from './courier.service';
import { DocumentService } from './document.service';

@NgModule({
  providers: [
    CourierService,
    DocumentService,
    DevStateResolver,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BannedAccountInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
  ],
})
export class DevServicesModule {
}
